import { useMutation } from "@tanstack/react-query";
import httpClient from "../httpClient";

export const useDownloadReceiptMutation = ({
  authorisation = "",
  itemId,
}: {
  itemId: string;
  authorisation: string;
}) => {
  return useMutation(
    async () =>
      httpClient(`payment/pay/${itemId}/receipt`, {
        authorisation,
      }).getNamedBlob(),
    {
      onSuccess: ({ blob, filename }: { blob: Blob; filename?: string }) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename ?? `receipt-${itemId}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      },
    }
  );
};
